import { InjectionToken, Signal } from '@angular/core';
import { Entity } from '@libs/mtjr/shared/generated/types';

/**
 * Optional token for providing the currently selected address.
 * Used by AddressPage to show which address is selected (e.g., in cart checkout flow).
 * Apps that don't have a cart/checkout flow don't need to provide this.
 */
export interface AddressProvider {
  address: Signal<Entity.UserAddress | undefined>;
}

export const ADDRESS_PROVIDER = new InjectionToken<AddressProvider>('ADDRESS_PROVIDER');
